import crypto from 'crypto';

export const createMD5Hash = (stringToEncode: string) => crypto.createHash('md5').update(stringToEncode).digest('hex');
